export const dueDatesPages = {
  master: () => import('./pages/DueDatesPage'),
};
